export default {
  'footer:social-title': 'Mis geen nieuws & acties meer!',
  'footer:newsletter-title':
    'Meld je aan voor onze nieuwsbrief en verzeker je van een kortingsbon van 15%.',
  'footer:newsletter-input-placeholder': 'Jouw e-mailadres',
  'footer:newsletter-button-cat': 'Kattenfan',
  'footer:newsletter-button-dog': 'Hondenfan',
  'footer:newsletter-unsubscribe-notice':
    'Kortingsbon alleen geldig voor je eerste bestelling. {br} Met je aanmelding ga je akkoord met ons <a>privacybeleid</a>. {br} <strong>Je kunt je op elk moment weer afmelden.</strong>',
  'footer:newsletter-main-title': 'Nieuwsbrief',
  'footer:newsletter-petsdeli-hashtag': '#petsdelifamily',
  'footer:social-facebook': 'Facebook',
  'footer:social-instagram': 'Instagram',
  'footer:social-ambassador-program': 'Merkambassadeur worden',

  'footer:title-valuable': 'Goed om te weten',
  'footer:title-good-for-you': 'Goodies voor jou',
  'footer:title-help': 'Hulp',
  'footer:title-shipping': 'Betrouwbare bezorging met',
  'footer:title-payment': 'Betaal met',
  'footer:title-legal': 'Pets Deli',
  'footer:help-title': 'Vragen? Stel ze gerust! We helpen jou en je lieveling graag verder.',
  'footer:newsletter-thank-you':
    'Bedankt voor je aanmelding! {br} We hebben je een bevestigingsmail gestuurd.',
  'footer:refer-friend:title': '{amount} voor jou, {amountFriend} voor je vriend(in)',
  'footer:refer-friend:subtitle': 'zo werkt het',

  'footer:refer-friend:steps:copy-link': 'Deel Pets Deli met je vrienden',
  'footer:refer-friend:steps:share-with-friend':
    'Je vriend(in) krijgt automatisch {amountFriend} korting bij de eerste aankoop',
  'footer:refer-friend:steps:result':
    'Je ontvangt je {amount}-tegoed zodra je vriend(in) heeft besteld.',

  'footer:link-section:opening-hours': 'Ma-vr, 9-18 uur',
  'footer:link-section:link-help': 'Heb je hulp nodig?',
  'footer:link-section:customer-support-phone-number': '{phone}',
  'footer:link-section:whatsapp-number': '{whatsapp}',
  'footer:link-section:language-switcher': 'Taal kiezen',
  'footer:link-section:widerruf-button': 'Overeenkomst herroepen',
  'footer:link-section:widerruf-aria': 'Overeenkomst herroepen – herroepingsformulier openen',
};
